import React, { useState, useEffect } from "react";
import {
	Box,
	Avatar,
	Typography,
	Paper,
	CircularProgress,
	Alert,
} from "@mui/material";
import axios from "axios";

const DashboardProfilePage = () => {
	const [user, setUser] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState("");

	// Fetch user data from API
	useEffect(() => {
		const fetchUser = async () => {
			try {
				const response = await axios.get("/api/user"); // Your API endpoint
				setUser(response.data);
			} catch (err) {
				setError("Failed to load user data.");
			} finally {
				setLoading(false);
			}
		};

		fetchUser();
	}, []);

	if (loading) {
		return (
			<Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
				<CircularProgress />
			</Box>
		);
	}

	if (error) {
		return (
			<Box sx={{ p: 4 }}>
				<Alert severity="error">{error}</Alert>
			</Box>
		);
	}

	return (
		<Box
			sx={{
				maxWidth: 600,
				mx: "auto",
				p: 4,
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				backgroundColor: "#fff",
				borderRadius: 2,
				boxShadow: 3,
			}}>
			{/* Profile Avatar */}
			<Avatar src={user.avatarUrl} sx={{ width: 120, height: 120, mb: 2 }} />

			{/* User Name */}
			<Typography variant="h5" gutterBottom>
				{user.name}
			</Typography>

			{/* User Details */}
			<Paper sx={{ width: "100%", p: 2, mb: 2, backgroundColor: "#f5f5f5" }}>
				<Typography variant="subtitle1" gutterBottom>
					Email:
				</Typography>
				<Typography variant="body1" gutterBottom>
					{user.email}
				</Typography>

				<Typography variant="subtitle1" gutterBottom>
					Phone:
				</Typography>
				<Typography variant="body1" gutterBottom>
					{user.phone}
				</Typography>

				<Typography variant="subtitle1" gutterBottom>
					Address:
				</Typography>
				<Typography variant="body1">{user.address}</Typography>
			</Paper>
		</Box>
	);
};

export default DashboardProfilePage;
